import styled from 'styled-components';

export const StyledEmptyItem = styled.li`
  display: grid;
  padding: 1rem;
  gap: 1rem;
`;

export const StyledDemoDragDropList = styled.ul`
  list-style: none;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0.5rem;
`;

export const StyledDemoDragDropListItem = styled.li<{ useDragHandle?: boolean }>`
  border: 0.0625rem dashed gray;
  margin: 0.5rem;
  padding: 0.5rem;
  background: white;
  cursor: ${({ useDragHandle }) => (useDragHandle ? 'auto' : 'move')};
  transition: transform 0.3s;

  .handle {
    background: pink;
    width: 1rem;
    height: 1rem;
    display: inline-block;
    margin-right: 0.0625rem;
    cursor: move;
  }
`;
